<div class="dashboard-content branches-page" style="padding: 120px 40px 50px">
  <div class="billing-and-payments-screen">

    <!-- Standard page heading: title left, search + primary action right -->
    <div class="page-heading">
      <h3>{{ 'branches.title' | translate }}</h3>
      <div class="heading-right" *ngIf="activeTab === 'branches'">
        <div class="search">
          <input type="text" class="form-control" [(ngModel)]="searchTerm"
            [placeholder]="'branches.search-placeholder' | translate" autocapitalize="off"
            style="text-transform: none;">
          <i class="fa-solid fa-magnifying-glass"></i>
          <i class="fa-solid fa-xmark clear-search" *ngIf="searchTerm" (click)="searchTerm = ''"
            style="cursor: pointer;"></i>
        </div>
        <button class="btn btn-primary" (click)="openCreateModal()">
          {{ 'branches.new-branch' | translate }}
        </button>
      </div>
    </div>

    <!-- Tabs: the branch list, and registering a QR level. Uses the app's
         standard custom-tabs markup (same as Participants) rather than a
         bespoke set, so the two screens read alike. -->
    <div class="custom-tabs-container">
      <div class="custom-tabs-header">
        <ul class="custom-nav-tabs" role="tablist">
          <li class="nav-item">
            <a (click)="switchTab('branches')" [class.active]="activeTab === 'branches'" class="nav-link" role="tab">
              {{ 'branches.tab-branches' | translate }}
              <span *ngIf="branches.length">({{ branches.length }})</span>
            </a>
          </li>
          <li class="nav-item">
            <a (click)="switchTab('qr')" [class.active]="activeTab === 'qr'" class="nav-link" role="tab">
              {{ 'branches.tab-qr' | translate }}
              <span *ngIf="registeredQrs.length">({{ registeredQrs.length }})</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- ══ QR REGISTRATION TAB ══ -->
    <div class="luqta-card" *ngIf="activeTab === 'qr'">
      <div class="card-heading">
        <h3>{{ 'branches.qr-title' | translate }}</h3>
      </div>

      <p class="text-muted small qr-hint">{{ 'branches.qr-hint' | translate }}</p>

      <div *ngIf="!isLoadingContests && contestsError" class="qr-alert error">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ contestsError }}</span>
        <button class="btn btn-light filter-btn" (click)="loadContests()">
          <i class="fa-solid fa-rotate"></i>
          <span>{{ 'branches.retry' | translate }}</span>
        </button>
      </div>

      <p *ngIf="!isLoadingContests && !contestsError && contests.length === 0" class="text-muted small mb-0">
        {{ 'branches.qr-no-contests' | translate }}
      </p>

      <div class="qr-form" *ngIf="!isLoadingContests && !contestsError && contests.length > 0">
        <div class="qr-field">
          <label class="form-label font-weight-600 mb-2">
            {{ 'branches.qr-contest' | translate }} <span class="text-danger">*</span>
          </label>
          <nz-select class="w-100" [(ngModel)]="selectedContestId" (ngModelChange)="onContestChange()"
            [nzPlaceHolder]="'branches.qr-contest-placeholder' | translate" nzShowSearch nzAllowClear>
            <nz-option *ngFor="let c of contests" [nzValue]="c.id" [nzLabel]="c.name"></nz-option>
          </nz-select>
        </div>

        <div class="qr-field">
          <label class="form-label font-weight-600 mb-2">
            {{ 'branches.qr-level' | translate }} <span class="text-danger">*</span>
          </label>
          <nz-select class="w-100" [(ngModel)]="selectedLevelId" (ngModelChange)="onLevelChange()"
            [nzDisabled]="!selectedContestId || isLoadingLevels" [nzLoading]="isLoadingLevels"
            [nzPlaceHolder]="(selectedContestId ? 'branches.qr-level-placeholder' : 'branches.qr-level-disabled') | translate"
            nzShowSearch nzAllowClear>
            <nz-option *ngFor="let l of levels" [nzValue]="l.id"
              [nzLabel]="l.name + (isQrLevel(l) ? '  •  ' + ('branches.qr-type-badge' | translate) : '')"></nz-option>
          </nz-select>
        </div>

        <div class="qr-actions">
          <button class="btn btn-primary" (click)="registerQr()" [disabled]="!canRegister">
            <span *ngIf="isRegistering" class="spinner-border spinner-border-sm me-2"></span>
            {{ (isRegistering ? 'branches.qr-registering' : 'branches.qr-register') | translate }}
          </button>
        </div>
      </div>

      <div *ngIf="qrSuccess" class="qr-alert success mt-3">
        <i class="fa-solid fa-circle-check"></i>
        <span>{{ qrSuccess }}</span>
      </div>

      <div *ngIf="qrError" class="qr-alert error mt-3">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ qrError }}</span>
      </div>
    </div>

    <!-- ══ REGISTERED QR LEVELS (getBranchByClient) ══ -->
    <div class="luqta-card" *ngIf="activeTab === 'qr'">
      <div class="card-heading">
        <h3>
          {{ 'branches.qr-registered-title' | translate }}
          <span *ngIf="registeredQrs.length">({{ registeredQrs.length }})</span>
        </h3>
        <button class="btn btn-light filter-btn" (click)="loadRegisteredQrs()" [disabled]="isLoadingRegisteredQrs">
          <i class="fa-solid fa-rotate" [class.fa-spin]="isLoadingRegisteredQrs"></i>
          <span>{{ 'branches.retry' | translate }}</span>
        </button>
      </div>

      <div *ngIf="!isLoadingRegisteredQrs && registeredQrsError" class="qr-alert error">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ registeredQrsError }}</span>
      </div>

      <p *ngIf="!isLoadingRegisteredQrs && !registeredQrsError && registeredQrs.length === 0"
        class="text-muted small mb-0">
        {{ 'branches.qr-registered-empty' | translate }}
      </p>

      <!-- Columns follow what my_registrations actually returns: the campaign
           and level are identified by UID, and there is no branch on the row.
           clientName / clientApiKey are the same on every row (the list is
           already scoped to this client) so they are not repeated here — and
           the API key is a credential that does not belong in a listing. -->
      <nz-table *ngIf="!isLoadingRegisteredQrs && !registeredQrsError && registeredQrs.length > 0"
        #registeredQrsTable [nzData]="registeredQrs" [nzBordered]="true" [nzPageSize]="10"
        [nzShowPagination]="registeredQrs.length > 10" [nzScroll]="{ x: '760px' }">
        <thead>
          <tr>
            <th nzWidth="90px">#</th>
            <th nzWidth="280px">{{ 'branches.qr-contest' | translate }}</th>
            <th nzWidth="200px">{{ 'branches.qr-level' | translate }}</th>
            <th nzWidth="190px">{{ 'branches.qr-registered-on' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let qr of registeredQrsTable.data; let i = index">
            <td><span class="id-badge">#{{ qr.id || (i + 1) }}</span></td>
            <td>
              <div class="d-flex align-items-center gap-3">
                <div class="branch-avatar">
                  <i class="fa-solid fa-qrcode"></i>
                </div>
                <span class="branch-name" [title]="qr.contestUid">
                  {{ campaignLabelForUid(qr.contestUid) }}
                </span>
              </div>
            </td>
            <td><span class="uid-cell" [title]="qr.levelUid">{{ shortUid(qr.levelUid) }}</span></td>
            <td>{{ qr.createdAt ? (qr.createdAt | date: 'dd/MM/yy hh:mm a') : '-' }}</td>
          </tr>
        </tbody>
      </nz-table>
    </div>

    <!-- Loading -->
    <!-- The list request failed: explain it here rather than in a popup -->
    <div class="luqta-card load-error-card" *ngIf="activeTab === 'branches' && !isLoading && loadError">
      <div class="error-body">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <div class="error-text">
          <h5>{{ 'branches.load-failed' | translate }}</h5>
          <p class="mb-0">{{ loadError }}</p>
        </div>
        <button class="btn btn-light filter-btn" (click)="loadBranches()">
          <i class="fa-solid fa-rotate"></i>
          <span>{{ 'branches.retry' | translate }}</span>
        </button>
      </div>
    </div>

    <!-- Branches table -->
    <div class="luqta-card" *ngIf="activeTab === 'branches' && !isLoading && !loadError">
      <div class="card-heading">
        <h3>{{ 'branches.title' | translate }} ({{ branches.length }})</h3>
      </div>

      <nz-table #branchesTable [nzData]="filteredBranches" [nzBordered]="true" [nzFrontPagination]="false"
        [nzShowPagination]="false" [nzScroll]="{ x: '720px' }" [nzNoResult]="noBranchesTpl">
        <thead>
          <tr>
            <th nzWidth="120px" class="ps-4">{{ 'branches.col-id' | translate }}</th>
            <th nzWidth="auto" class="text-center">{{ 'branches.col-name' | translate }}</th>
            <th nzWidth="140px" class="text-center">{{ 'branches.col-actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let branch of branchesTable.data">
            <td class="ps-4">
              <span class="id-badge">#{{ branch.id }}</span>
            </td>
            <td class="text-center">
              <div class="branch-cell-content">
                <div class="branch-avatar">
                  <i class="fa-solid fa-store"></i>
                </div>
                <span class="branch-name" [title]="branch.branchName">{{ branch.branchName }}</span>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center justify-content-center gap-2">
                <button class="btn-icon-action" (click)="openEditModal(branch, $event)"
                  [title]="'branches.edit-branch' | translate">
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
                <button class="btn-icon-action btn-icon-danger" (click)="openDeleteModal(branch, $event)"
                  [title]="'branches.delete-branch' | translate">
                  <i class="fa-solid fa-trash-can"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <ng-template #noBranchesTpl>
        <div class="text-center py-5">
          <i class="fa-solid fa-store text-muted mb-3 d-block" style="font-size: 42px;"></i>
          <h5 class="font-weight-600">{{ 'branches.empty-title' | translate }}</h5>
          <p class="text-muted small mb-4">
            {{ (searchTerm ? 'branches.empty-search' : 'branches.empty-desc') | translate }}
          </p>
          <button class="btn btn-primary" *ngIf="!searchTerm" (click)="openCreateModal()">
            {{ 'branches.create-first' | translate }}
          </button>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- Create / Edit Branch Modal -->
  <nz-modal nzClassName="luqta-custom-modal" [nzCentered]="true" [(nzVisible)]="isFormModalVisible"
    [nzTitle]="createTitle" [nzContent]="createContent" [nzFooter]="createFooter" (nzOnCancel)="closeFormModal()"
    [nzWidth]="520">

    <ng-template #createTitle>
      <div class="d-flex align-items-center gap-2">
        <div class="modal-branch-icon">
          <i class="fa-solid" [class.fa-store]="!isEditMode" [class.fa-pen-to-square]="isEditMode"></i>
        </div>
        <span style="font-family: 'Codec Pro'; font-weight: 600; font-size: 17px; color: #FFFFFF;">
          {{ (isEditMode ? 'branches.edit-branch' : 'branches.new-branch') | translate }}
        </span>
      </div>
    </ng-template>

    <ng-template #createContent>
      <div class="branch-form py-3 px-1">
        <label class="form-label font-weight-600 mb-2">
          {{ 'branches.field-name' | translate }} <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control luqta-input" [(ngModel)]="branchNameInput"
          (ngModelChange)="onNameInput()" [placeholder]="'branches.name-placeholder' | translate"
          [class.is-invalid]="!!inlineError" (keyup.enter)="handleSave()" />

        <div *ngIf="inlineError" class="field-error">
          <i class="fa-solid fa-circle-exclamation"></i>{{ inlineError }}
        </div>

        <small class="text-muted d-flex align-items-center gap-1 mt-2" style="font-size: 12px;">
          <i class="fa-solid fa-circle-info" style="color: #5304FB;"></i>
          {{ 'branches.name-hint' | translate }}
        </small>
      </div>
    </ng-template>

    <ng-template #createFooter>
      <div class="d-flex justify-content-end align-items-center gap-2">
        <button class="btn btn-light" (click)="closeFormModal()" [disabled]="isSaving"
          style="border-radius: 12px; height: 48px; padding: 0 22px; font-size: 14px; font-weight: 500; border: 1.5px solid rgba(0, 0, 0, 0.1); background: #FFFFFF; color: #344054;">
          {{ 'branches.cancel' | translate }}
        </button>
        <button class="btn btn-primary" (click)="handleSave()" [disabled]="isSaving || !isFormValid"
          style="border-radius: 12px; height: 48px; padding: 0 24px; font-size: 16px; font-weight: 500; font-family: 'Codec Pro', sans-serif; background: linear-gradient(62.82deg, #8F67FD -31.84%, #5304FB 80.32%); border: none; color: #FFFFFF; box-shadow: 0 4px 14px rgba(83, 4, 251, 0.28);">
          <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2"></span>
          {{ isSaving
              ? ('branches.saving' | translate)
              : (isEditMode ? ('branches.save-changes' | translate) : ('branches.create' | translate)) }}
        </button>
      </div>
    </ng-template>
  </nz-modal>

  <!-- Delete confirmation -->
  <nz-modal
    [(nzVisible)]="isDeleteModalVisible"
    [nzCentered]="true"
    [nzFooter]="null"
    (nzOnCancel)="closeDeleteModal()"
    nzClassName="pricing-modal"
  >
    <ng-container *nzModalContent>
      <div class="downgrade-modal">
        <h5>{{ 'branches.delete-branch' | translate }}</h5>
        <p>
          {{ 'branches.delete-confirm' | translate }} <b>"{{ deletingBranch?.branchName }}"</b> (ID #{{ deletingBranch?.id }})?
        </p>
        <div class="alert alert-warning d-flex align-items-start gap-2 p-3 mt-3 mb-4"
          style="border-radius: 10px; background: #FFFBEB; border: 1px solid #FDE68A; color: #B45309; font-size: 13px;">
          <i class="fa-solid fa-triangle-exclamation mt-0.5"></i>
          <div>{{ 'branches.delete-warning' | translate }}</div>
        </div>
        <div class="bottom-btns">
          <button class="btn btn-cancel" (click)="closeDeleteModal()" [disabled]="isDeleting">
            {{ 'branches.cancel' | translate }}
          </button>
          <button class="btn btn-downgrade" (click)="handleDelete()" [disabled]="isDeleting">
            <span *ngIf="isDeleting" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!isDeleting" class="fa-solid fa-trash-can me-2"></i>
            {{ isDeleting ? ('branches.deleting' | translate) : ('branches.delete-branch' | translate) }}
          </button>
        </div>
      </div>
    </ng-container>
  </nz-modal>

</div>
